import { render, staticRenderFns } from "./InputPaySectionComponent.vue?vue&type=template&id=16895d9c&scoped=true&"
import script from "./InputPaySectionComponent.vue?vue&type=script&lang=js&"
export * from "./InputPaySectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputPaySectionComponent.vue?vue&type=style&index=0&id=16895d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16895d9c",
  null
  
)

export default component.exports